define((require) => {
    "use strict";

    const ImprovedView           = require("editor/zbone/ImprovedView");
    const ImageTagCompositeView  = require("ui/assets/image/tags/ImageTagCompositeView");
    const template               = require("ui/assets/image/ImageTooltipView.tpl");

    return ImprovedView.extend({

        template,

        regions: {
            imageTagsRegion: ".imageTagsRegion"
        },

        templateHelpers() {
            const {showExtension, showTags, isScene7} = this.options;
            return {
                altText: this.model.get("altText") || "",
                showTags,
                showExtension,
                isScene7
            };
        },

        onRender() {
            const {showTags} = this.options;

            if (showTags) {
                this.imageTagsRegion.show(new ImageTagCompositeView({
                    collection: this.model.get("tags").newCopySortedByConfidence(5)
                }));
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/assets/image/ImageTooltipView.js